import React from "react";
import "../../../stylesheet/components/contentcards/skeleton/ContentCardSkeleton.scss";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ContentCardSkeleton: React.FC = () => {
	return (
		<div className="skeleton-card-outer">
			<div className="skeleton-image-container" />
			<div className="skeleton-card-inner">
				<Skeleton width={40} />
				<Skeleton width={60} height={30} style={{ marginBottom: "1rem" }} />
				<Skeleton count={5} />
				<Skeleton width={40} style={{ marginTop: "1rem" }} />
			</div>
		</div>
	);
};

export default ContentCardSkeleton;
